<i class="far fa-exclamation" data-fa-symbol="exclamation-simple"></i>

<div class="wrapper">
  <div class="table-container">
    <qm-filters
      [filterDefinitions]="trainTypeFilters"
      (filtersChanged)="filtersChanged($event)"
      [position]="'left'" style="width:100%;">
    </qm-filters>
    <table class="table table-sm table-hover" *qmLoading="loading">
      <thead>
      <tr>
        <th [style.width]="columnWidths.train">
          {{'Train' | translate}}
        </th>
        <th [style.width]="columnWidths.route">
          {{'Route' | translate}}
        </th>
        <th colspan="2">
          {{'Status information' | translate}}
        </th>
      </tr>
      </thead>
      <tbody>
      <ng-template ngFor let-train [ngForOf]="displayedTrains | slice:0:listLimit">
        <tr
          [ngClass]="getRowClass | applyFunction:train"
          *ngIf="trainVisible | applyFunction:train:trainFilter" >
          <td
            (click)="openTrainInfo(train)"
            class="clickable-text"
            [style.width]="columnWidths.train">
            {{train.title}} {{train.subTitle}}
          </td>
          <td [style.width]="columnWidths.route">
            {{train.depStation}} - {{train.arrStation}}
          </td>
          <!-- Status information -->
          <td [style.width]="columnWidths.time">
            <span class="badge badge-pill" [ngClass]="'badge-' + train.status">{{train.calculatedDelta}}</span>
          </td>
          <td>
            <span
              class="badge badge-warning clickable"
              ngbTooltip="{{ 'See VAK info from cargo manifest' | translate }}"
              *ngIf="train.vak"
              (click)="openCargoInfo(train)"
            >
              VAK
            </span>
            <span
              *ngFor="let cause of train.causes | qmMapValues"
              (click)="selectAlarmOverlayTrain(train); alarmDetails.toggle($event); $event.stopPropagation();"
              class="clickable"
              ngbTooltip="{{ 'Details' | translate }}"
            >
              {{ cause.val.determinedKonegisCauseCode }}
            </span>
            <qm-train-list-alarm-icons [train]="train"></qm-train-list-alarm-icons>
          </td>
        </tr>
      </ng-template>

      <div [ngStyle]="{width: '100%', padding: '1em', textAlign: 'center'}">
        <button
          *ngIf="listLimit < displayedTrains.length"
          (click)="onLoadMoreBtnClicked()"
          class="btn btn-outline-info">
          {{ 'Load more' | translate }}
        </button>
      </div>

      </tbody>
    </table>
  </div>
</div>

<qm-overlay-panel #alarmDetails [stickTo]="'left-bottom'" [appendTo]="'body'" [dismissable]="true" [skipFirstClick]="false">
    <div class="card hover-container" *ngIf="alarmOverlaySelectedTrain">
        <div class="card-header">
          {{ alarmOverlaySelectedTrain.title }} {{ alarmOverlaySelectedTrain.subTitle}} {{ 'Status' | translate }}
        </div>
        <div class="card-body">
          <ng-container *ngIf="alarmOverlaySelectedTrain.causes && alarmOverlaySelectedTrain.causes.size > 0; else noCauseCodes;">
              <h5>{{ 'Reason code details' | translate }} </h5>
              <span *ngFor="let cause of alarmOverlaySelectedTrain.causes | qmMapValues">
                  {{ cause.val.determinedKonegisCauseCode }} {{ cause.val.liviCauseCode?.categoryName }}
                  <div class="rounded border border-danger" style="display: block; width: 5em; text-align: center">
                    <a href="http://liike/kuti/#/aikataulupoikkeamat" target="_blank" id="challenge-link">{{ 'Challenge' | translate}}</a>
                  </div>
              </span>
              <br />
          </ng-container>
          <ng-template #noCauseCodes>
            <p>{{ 'No active reason code' | translate }}</p>
          </ng-template>

        <!--<ng-container *ngIf="hasActiveConflictAlarms | applyFunction:alarmOverlaySelectedTrain; else noConflicts">
              <h5>{{ 'Conflicts' | translate }}</h5>
              <div *ngFor="let alarm of getActiveConflictAlarms | applyFunction:alarmOverlaySelectedTrain">
                <div>
                  {{ getTranslatedAlarm | applyFunction:alarm }}
                </div>
              </div>
            </ng-container>
            <ng-template #noConflicts>
                <p>{{ 'No conflicts' | translate }}</p>
            </ng-template>
          -->
        </div>
    </div>
</qm-overlay-panel>

<ng-template #conflictIcon>
    <i style="color: red; margin-left:5px;" class="far fa-exclamation-triangle"></i>
</ng-template>
<ng-template #technicalIcon>
  <i style="color: gray; margin-left:5px;" class="far fa-exclamation-triangle"></i>
</ng-template>
